import { Users, Award, Gem, Clock, ShieldCheck, HeartHandshake, FileCheck, Building2 } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, SectionHead } from "./Reveal";

const ICONS = [Users, Award, Gem, Clock, ShieldCheck, HeartHandshake, FileCheck, Building2];

export const WhyUs = () => {
  const { t } = useLang();
  return (
    <section id="why" data-testid="why-section" className="border-t border-white/10 bg-[#070707]">
      <div className="mx-auto max-w-[1500px] px-5 py-24 md:px-10 md:py-32">
        <SectionHead num={t.why.num} title={t.why.title} sub={t.why.sub} testid="why-head" />

        <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {t.why.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={(i % 4) * 0.07} className="bg-[#0A0A0A]">
                <div
                  data-testid={`why-item-${i}`}
                  className="group h-full p-8 transition-colors duration-500 hover:bg-[#101010]"
                >
                  <Icon size={28} className="text-[#FF5A00] transition-transform duration-500 group-hover:-translate-y-1" />
                  <h3 className="mt-5 font-display text-xl uppercase tracking-wide">{item.t}</h3>
                  <p className="mt-2 text-sm text-neutral-400">{item.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
